const dedupeMacVolumePathPrefix = (filePath: string): string => {
  let normalized = filePath.replace(/\\/g, '/').replace(/\/+/g, '/');
  const duplicateVolumePrefix = /^(\/?)(Volumes\/[^/]+)\/\2\//i;
  while (duplicateVolumePrefix.test(normalized)) {
    normalized = normalized.replace(duplicateVolumePrefix, '$1$2/');
  }
  return normalized;
};

export const normalizePath = (filePath: string | undefined | null): string => {
  if (typeof filePath !== 'string') return '';
  // Normalize backslashes to forward slashes
  let normalized = dedupeMacVolumePathPrefix(filePath);
  // Normalize multiple slashes to single slash
  normalized = normalized.replace(/\/+/g, '/');
  // For absolute paths (starting with drive letter or /), ensure consistent leading slash
  // Windows paths like "C:/" should stay as "C:/"
  // Unix paths like "/Users" should stay as "/Users"
  // But paths like "Users/..." should become "/Users/..." if they're absolute
  if (normalized.match(/^[A-Za-z]:/)) {
    // Windows absolute path - keep as is
    return normalized;
  } else if (normalized.startsWith('/')) {
    // Unix absolute path - keep leading slash
    return normalized;
  } else if (normalized.length > 0 && !normalized.includes('..')) {
    // If it looks like an absolute path (starts with common absolute path patterns)
    // but missing leading slash, add it
    const commonAbsolutePatterns = [
      /^Users\//,
      /^home\//,
      /^var\//,
      /^etc\//,
      /^usr\//,
      /^tmp\//,
      /^Volumes\//i,
    ];
    if (commonAbsolutePatterns.some((pattern) => pattern.test(normalized))) {
      return '/' + normalized;
    }
  }
  return normalized;
};
